<template>
    <div class="columns header is-marginless" :class="customClass">
        <div class="column">
            <div class="column" :class="defaultSize">
                <img :src="logoUrl" class="logo" />
                <section class="hero">
                    <div class="hero-body is-paddingless">
                        <h1 class="title is-size-4-mobile" :class="{'has-text-centered has-text-white' : center}" v-if="title">
                            {{title}}
                        </h1>
                        <h2 class="subtitle is-marginless is-size-6-mobile" v-if="desc">
                            {{desc}}
                        </h2>
                        <p class="is-hidden-tablet has-text-info is-flex privacy-mobile" v-if="privacy">Gizliliğin Nasıl Korunuyor
                            <b-tooltip label="Verilerini yayınlarken, kişisel bilgilerini kesinlikle paylaşmıyoruz. Şirket adı, pozisyon adı ve mülakat soruları isimsiz olarak yayınlanacaktır. "
                                       type="is-tooltip"
                                       :multilined="true"
                                       position="is-bottom">
                                <b-icon icon="help-circle-outline" style="cursor: pointer;"> </b-icon>
                            </b-tooltip>
                        </p>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Top",
        props:['title', 'desc', 'logoType', 'center', 'privacy', 'customClass', 'sizeClass'],
        computed:{
            logoUrl(){
                return this.logoType ? require(`../assets/img/logo-${this.logoType}.svg`) : require(`../assets/img/logo.svg`)
            },
            defaultSize(){
                return this.sizeClass ? this.sizeClass : 'is-7'
            }
        }
    }
</script>